export enum SupplierRequestSources {
    wizard = 'WIZARD',
    wizardDocumentUpload = 'WIZARD_DOCUMENT_UPLOAD',
    email = 'EMAIL',
    external = 'EXTERNAL',
  }

  export enum SupplierRequestSourcesLabels {
    WIZARD = 'Wizard',
    WIZARD_DOCUMENT_UPLOAD = 'Document Upload',
    EMAIL = 'Email',
    EXTERNAL = 'External',
  }
  